import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';
import _ from 'underscore';

import { buildQueryParameters, extractQueryParameters } from 'helpers/RoutesHelpers';
import { getLocationSelector } from '../commons/selectors/RouterSelector';

const propTypes = {
    RouterActions: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    to: PropTypes.any.isRequired,
    modalName: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
};

class ModalLink extends Component {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick(e) {
        e.preventDefault();
        const {
            RouterActions,
            location,
            modalName,
            to,
        } = this.props;
        const newLocation = location;
        const searchParameters = extractQueryParameters(location.search);
        searchParameters[`${modalName}-modal`] = to;
        newLocation.search = buildQueryParameters(searchParameters);
        RouterActions.push(newLocation);
    }

    render() {
        return (
            <Link
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {..._.omit(this.props, ['RouterActions', 'modalName', 'location'])}
                onClick={this.onClick}
            />
        );
    }

}

ModalLink.propTypes = propTypes;

export default connect(
    (state) => ({
        location: getLocationSelector(state),
    }),
    (dispatch) => ({
        RouterActions: bindActionCreators({
            push,
        }, dispatch),
    }),
)(ModalLink);
